<!-- 確認画面用企業情報テーブル: 顧客/管理者/代理店情報を共通表示 -->
<template>
  <ConfirmRow :label="companyLabel" :value="data.company" />
  <AddressRows :address="data" />
  <ConfirmRow label="所属部署 / 役職名" :value="data.department" />
  <ConfirmRow label="お名前" :value="data.name" />
  <ConfirmRow label="お名前（フリガナ）" :value="data.furigana" />
  <ConfirmRow label="メールアドレス" :value="data.email" />
  <ConfirmRow label="電話番号" :value="data.tel" />
  <ConfirmRow
    v-if="showMailDelivery"
    label="製品・サポート情報の配信"
    :value="data.mailDelivery"
  />
  <ConfirmRow
    v-if="data.subName"
    label="お名前（運用者等）"
    :value="data.subName"
  />
  <ConfirmRow
    v-if="data.subEmail"
    label="メールアドレス（運用者等）"
    :value="data.subEmail"
  />
</template>

<script setup lang="ts">
import ConfirmRow from "./ConfirmRow.vue";
import AddressRows from "./AddressRows.vue";

interface CompanyData {
  company?: string | null;
  zip?: string | null;
  prefecture?: string | null;
  city?: string | null;
  address1?: string | null;
  building?: string | null;
  department?: string | null;
  name?: string | null;
  furigana?: string | null;
  email?: string | null;
  tel?: string | null;
  mailDelivery?: string | null;
  subName?: string | null;
  subEmail?: string | null;
}

withDefaults(
  defineProps<{
    data: CompanyData;
    companyLabel?: string;
    showMailDelivery?: boolean;
  }>(),
  {
    companyLabel: "法人名 / 団体名",
    showMailDelivery: true,
  },
);
</script>
